import { Routes, Route, useNavigate } from 'react-router-dom';
import { ErrorBoundary, ErrorMessage } from './components/ui/ErrorBoundary';

// Pages
import Home from './pages/Home';
import GalleryBrowse from './pages/GalleryBrowse';
import GalleryView from './pages/GalleryView';
import Player from './pages/Player';
import Controller from './pages/Controller';
import Login from './pages/Login';
import Register from './pages/Register';
import ArtistDashboard from './pages/ArtistDashboard';
import NotFound from './pages/NotFound';

// Global error fallback
function GlobalErrorFallback() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gallery-950">
      <ErrorMessage
        title="Something went wrong"
        message="An unexpected error occurred. Please try refreshing the page."
        onRetry={() => window.location.reload()}
        onGoBack={() => navigate(-1)}
      />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary fallback={<GlobalErrorFallback />}>
      <Routes>
      {/* Public routes */}
      <Route path="/" element={<Home />} />
      <Route path="/galleries" element={<GalleryBrowse />} />
      <Route path="/galleries/:id" element={<GalleryView />} />

      {/* Auth routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Playback routes */}
      <Route path="/play/:roomCode" element={<Player />} />
      <Route path="/control/:roomCode" element={<Controller />} />

      {/* Artist routes */}
      <Route path="/artist/*" element={<ArtistDashboard />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </ErrorBoundary>
  );
}

export default App;
